import { StaticProvider } from '@angular/core';
import { PageSettingsStore } from './page-settings.store';
import { SOFTLINE_CONFIG_INDEXED_DB, SOFTLINE_STORE_FEATURES } from '@softline/core';
import { SOFTLINE_INDEXED_DB_USER } from '../user.indexed-db';

export const pageSettingsProviders: StaticProvider[] = [
  { provide: SOFTLINE_STORE_FEATURES, useExisting: PageSettingsStore, multi: true },
]
